import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-100 whitespace-nowrap">
                火影黄漫导航
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              汇聚火影忍者成人向同人漫画的完整资源导航与创作指南，为爱好者提供最优质的内容入口。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/ziyuan-daohang" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  资源导航
                </Link>
              </li>
              <li>
                <Link to="/category/chuangzuo-jiqiao" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  创作技巧
                </Link>
              </li>
              <li>
                <Link to="/category/huishi-tuijian" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  绘师推荐
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              更多内容
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/tongren-wenhua" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  同人文化
                </Link>
              </li>
              <li>
                <Link to="/category/shendu-jiexi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  深度解析
                </Link>
              </li>
              <li>
                <Link to="/category/shequ-zixun" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  社区资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              声明
            </h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              本站为火影同人爱好者自发建立的导航平台，所有链接内容均来自第三方平台。请确认已满18周岁再浏览成人向内容。同人创作请尊重原作版权。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 火影黄漫导航 - 正版资源导航与创作指南。本站为爱好者自发建立，与官方无关联。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}